export const GET_FILTER_WHERE_STAY_REQUEST = "GET_FILTER_WHERE_STAY_REQUEST";
export const GET_FILTER_WHERE_STAY_SUCCESS = "GET_FILTER_WHERE_STAY_SUCCESS";
export const GET_FILTER_WHERE_STAY_FAILURE = "GET_FILTER_WHERE_STAY_FAILURE";
